 /* eslint-disable */
import React, { useState, useEffect} from 'react'
import Vendors from './Vendors'
import AddVendor from './AddVendor'
import { getAllVendors } from '../../actions/vendorActions'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useHistory } from 'react-router-dom'
import NoData from '../svgIcons/NoData'
import Spinner from '../Spinner/Spinner'


const VendorList = () => {

    const history = useHistory()
    const location = useLocation()
    const [openVendor, setOpenVendor] = useState(false)
    const [currentId, setCurrentId] = useState(null)
    const dispatch = useDispatch()
    const user = JSON.parse(localStorage.getItem('profile'))
    const {vendors} = useSelector((state) => state.vendors)
    const isLoading = useSelector(state => state.vendors.isLoading)

    // const vendors = []

    
    // useEffect(() => {
    // }, [currentId, dispatch]);
    
//     useEffect(() => {
//         dispatch(getVendors(1));
//         // dispatch(getVendorsByUser({userId : user?.result?._id}));
//         // dispatch(getVendorsByUser({ search :user?.result?._id, tags: tags.join(',') }));
//     },[location]
// )

useEffect(() => {
    //console.log('user:',user)
    //user?.result?.id
    dispatch(getAllVendors());
  },[location, dispatch])

  if(!user) {
    history.push('/login')
  }

  
  if(isLoading) {
    return  <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', paddingTop: '20px'}}>
        <Spinner />
    </div>
  }

  if(vendors.length === 0) {
    return  <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', paddingTop: '20px', margin: '80px'}}>
      <NoData />
    <p style={{padding: '40px', color: 'gray', textAlign: 'center'}}>No vendors yet. Click the plus icon to add vendor</p>
  
    </div>
  }

    return (
        <div>
            <AddVendor 
                openVendor={openVendor} 
                setOpenVendor={setOpenVendor}
                currentId={currentId}
                setCurrentId={setCurrentId}
            />
            <Vendors 
                openVendor={openVendor} 
                setOpenVendor={setOpenVendor}
                currentId={currentId}
                setCurrentId={setCurrentId}
                vendors={vendors}
            />
        </div>
    )
}

export default VendorList

